import { CircularProgress } from "@mui/material";

const Loader: React.FC<{ size?: number }> = ({ size = 26 }) => {
  return <CircularProgress color="primary" size={size} thickness={4.5} />;
};
export default Loader;
